// extracted by mini-css-extract-plugin
module.exports = {"submit":"delete-area-modal_submit__DppKz"};